/**
 * Test IDs for QA automation.
 */
export const testIds = {
  quantityTypeSelectControl: "quantity-type-select-control",
  quantityTypeSelectOption: "quantity-type-select-option",
} as const;
